export default function NoProductImage({
	classNames = 'bg-gray-100',
	iconSize = 'fa-xl'
}: {
	classNames?: string
	iconSize?: string
}) {
	return (
		<div
			className={`flex flex-col items-center h-full justify-center text-gray-300 flex-1 ${classNames}`}
		>
			<i className={`fak fa-birchbox ${iconSize}`} />
		</div>
	)
}
